<template>
    <div class="quotesummary">
        <div class="row">
            <div class="header">
                <div>{{ quote.Summary }}</div>
            </div>
            <div class="image-container"><img ref="img" class="content-img" :src="getImageSrc()" /></div>  
            <div class="price">
                <div v-html="getDisplayPrice(quote)" />    
            </div>
            <div class="footer">      
                <span v-if="quote.StatusId == acceptedQuoteStatusId">Accepted</span>
                <span v-else-if="quote.TypeId == specialQuoteTypeId">Request a Quote</span>
            </div>
        </div>
    </div>
</template>

<script>     
    
    export default {
        name: 'QuoteSummary',
        components: {
        },
        data() {
            return {  
                quote: {}
            };
        },
        props: {
            value: {
                default: () => null
            }  
        },
        created: function () {  
            this.quote = this.value;        
            this.acceptedQuoteStatusId = this.getSetting('AcceptedQuoteStatusId');  
            this.specialQuoteTypeId = this.getSetting('SpecialQuoteTypeId');           
        },
        mounted: function () {
        },
        methods: {  
            getImageSrc() {
                var options = this.quote.Options;
                if(!this.isObject(options))
                {           
                    try {     
                        options = JSON.parse(this.quote.Options);
                        if(!options)
                            return;
                    }
                    catch {
                        return;
                    }
                }
               
                var manufacturer = options[0].Selection;
                var modelDataSourceId = 26;//options[2].DataSourceId;
                var modelKey = options[3].Selection;
                var imageUri = options[3].ImageUri;
                var noImageUri = 'https://fleetcarestorage.blob.core.windows.net/vehicleimages/noimage.jpg';

                if((!imageUri)) {
                    var url = this.apiUrl + 'datasources/26/data/' + modelKey;        
                    this.get(url, (response) => {
                        //console.log(response[0]);
                        if(response[0].imageUri) {
                            imageUri = response[0].imageUri;   
                        } else {
                            imageUri = noImageUri;
                        }
                        if(this.$refs.img) {
                            this.$refs.img.src = imageUri;
                        }
                    });
                }

                return imageUri; //'https://fleetcarestorage.blob.core.windows.net/vehicleimages/' + modelKey + '.jpg';
                
                /*
                var url = this.apiUrl + 'datasources/' + modelDataSourceId + '/data/' + modelKey + '?key=' + this.getCombinedKey();
                if(this.get(url,(data) => {
                    if(!(data) || data.length == 0)
                        return;
                    if(this.$refs.img) {
                        this.$refs.img.src ="data:image/png;base64, " + data[0].Data;
                    }
                }));*/
            },
            getDisplayPrice(quote) {
                var displayPrice = quote.DisplayPrice;

                var textarea = document.createElement("textarea");
                textarea.innerHTML = displayPrice;
                displayPrice = textarea.value;

                if(displayPrice) {
                    return '<div>' + displayPrice + '</div>';
                }
            }  
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>    
    .quotesummary {
        float: left; 
        text-align: center;
        width: 300px!important;
        border: #0f2c61!important;   
        border-radius: 10px;
        background: #0f2c61!important;   
    }
    .quotesummary > .row > .header {
        color: white;
        min-height: 95px;
        padding: 15px;
    }
    .quotesummary > .row > .price {
        color: black;
        background:#b8d8e3!important; 
        min-height: 60px;
        padding-top: 5px;
    }

    .quotesummary > .row > .price table {
        width:100%;
        display: inline;
        border-spacing: 10px;
    }

    .quotesummary > .row > .price table th {
        text-align: left;
        font-weight: normal;
        padding-right: 10px;
    }

    .quotesummary > .row > .price table td {
        text-align: right;
        padding-left: 10px;
    }
    
    .quotesummary > .row > .footer {
        color: white;
        min-height: 30px;
        font-size: 20px;
        font-weight: bold;
        padding: 15px;
    }
    .content-img {
        max-width:250px;
    }
    .image-container {
        background: white;
        width: 100%;
    }

    @media (max-width: 992px) {
        .quotesummary {
            min-width: 100%;
        }
    }

</style>